import companyType from '../type/company';
import quoteGQLString from '../util/quoteGQLString';

// Select the organization by its FEIN (the org business key) — never by the
// Firestore document id, which the API rejects.
export default (fein) => `
    org (
        fein: ${quoteGQLString(fein)}
    ) {
        ${companyType()}
    }
`;
